<template>
  <div class="app-container">
    <div class="main-content">
      <div class="head">
        <span>当前位置：</span>
        <div class="breadcrumb">
          <span class="route" @click="gohome">首页</span>
          <span>> </span>
          <span class="route" @click="gonews">新闻</span>
          <span>> </span>
          <span>{{ newsDetail.title || '新闻详情' }}</span>
        </div>
      </div>
      <div class="content">
        <div class="left">
          <div class="title">{{ newsDetail.title || '新闻标题' }}</div>
          <div class="date">{{ formatDate(newsDetail.createTime) }}</div>
          <div class="info" v-html="newsDetail.content || '暂无内容'">
          </div>
        </div>
        <div class="right">
          <div class="titlebox">
            <div class="linebox"></div>
            <div class="title">热门文章</div>
          </div>
          <div class="newsList">
            <div class="newstitle" v-for="(item, i) in hotNews" :key="i" @click="goToNewsDetail(item)">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAOCAYAAADE84fzAAABhElEQVQ4jZXUMWsUQRjG8d/kJJ6okYgINk5jZWdrK1jbiuAXEHtlQGyWILGIhdooiKAfwFr8AMHGQrQJstiIWJh4egkJNxY3K5vN7RGfZtl59v3Py8zzrphyiCkv6FFM+XxMOfT587RQVyFjOaZ8KqY8mPHNOXyIKd+IKR/5H3go3S3iDDLGGNVV2Gt1/xrX8QWreFFXYXwoeAEs41jL28avugq7MeWIzxgW7xse4Wldhc3DwAc4214r2sEI93Gn423iCdbqKnzvhZcNlnCip5GjWDc9vq628RyrdRXqZrGbkhEmPfAdPOzxhriFjZjyy5jyxQPwugoT7M0obvRxjgcDXMPNmPJwX7RiykMszim+O8f7gTU8rqvwE/7By6As9RSOcQWXZ3hfTeP5rBvPdufHO+8Zf0zvYYCVDvQTHuBVeyYOwMv4NymZNNByB2LKt3Gh+OtlozeN36em05PluYXf5ZeggE/jHt5ipa7Cu3nAffBy1rvYakNbuoSrdRXeHxba6C/6ToEqPDrdcwAAAABJRU5ErkJggg=="
                alt=""
              />
              <div>
                <div class="title">{{ item.title }}</div>
                <div class="date">{{ formatDate(item.createTime) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getnewsdetail, getnews } from "@/api/index.js";
export default {
  name: "newsdetails",
  components: {},
  data() {
    return {
      id: this.$route.query.id, // 从query参数获取ID
      newsDetail: {}, // 新闻详情
      hotNews: [], // 热门文章
    };
  },
  created() {
    if (this.id) {
      this.getNewsDetail();
      this.getHotNews();
    } else {
      this.$message.error('新闻ID参数缺失');
      this.gonews();
    }
  },
  methods: {
    // 获取新闻详情
    getNewsDetail() {
      getnewsdetail({ id: this.id }).then((res) => {
        if (res.data) {
          this.newsDetail = res.data;
        } else {
          this.$message.error('获取新闻详情失败');
        }
      }).catch(error => {
        console.error('获取新闻详情失败:', error);
        this.$message.error('获取新闻详情失败');
      });
    },
    
    // 获取热门文章
    getHotNews() {
      getnews({
        pageNo: 1,
        pageSize: 5,
        recommended: true // 获取推荐文章
      }).then((res) => {
        if (res.data && res.data.list) {
          // 过滤掉当前文章
          this.hotNews = res.data.list.filter(item => item.id != this.id);
          // 如果推荐文章不够，补充最新文章
          if (this.hotNews.length < 3) {
            this.getMoreNews();
          }
        }
      }).catch(error => {
        console.error('获取热门文章失败:', error);
      });
    },
    
    // 获取更多文章
    getMoreNews() {
      getnews({
        pageNo: 1,
        pageSize: 8
      }).then((res) => {
        if (res.data && res.data.list) {
          // 过滤掉当前文章和已有的热门文章
          const existingIds = this.hotNews.map(item => item.id);
          const moreNews = res.data.list.filter(item => 
            item.id != this.id && !existingIds.includes(item.id)
          );
          
          // 补充到5个文章
          const needed = Math.max(0, 5 - this.hotNews.length);
          this.hotNews = this.hotNews.concat(moreNews.slice(0, needed));
        }
      }).catch(error => {
        console.error('获取更多文章失败:', error);
      });
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '未知时间';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN') + ' ' + date.toLocaleTimeString('zh-CN', {hour12: false});
    },
    
    // 跳转到新闻详情
    goToNewsDetail(news) {
      this.$router.push({ path: "/newsdetals", query: { id: news.id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
    
    gohome() {
      this.$store.commit("activeNavIndex", 0);
      this.$router.push({ path: "/home" }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
    gonews() {
      this.$store.commit("activeNavIndex", 4);
      this.$router.push({ path: "/news" }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";
  color: #333;
  overflow: hidden;
  background: #f5f6f9;
  clear: both;
  text-align: left;
  .main-content {
    width: 1200px;
    margin: 0 auto;
    overflow: visible;
    position: relative;
    .head {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 20px 0;
      .breadcrumb{
        font-size: 14px;
        span{
            margin-right: 5px;
            cursor: default;
        }
        .route{
          &:hover{
            cursor: pointer;
          }
        }
      }
    }
    .content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 100px;
      .left {
        width: 740px;
        padding: 30px;
        background: #fff;
        border-radius: 10px;
        .title {
          font-size: 30px;
          color: #2d3341;
          margin-bottom: 30px;
        }
        .date {
          font-size: 16px;
          color: #838a9d;
          margin-bottom: 16px;
        }
      }
      .right {
        width: 320px;
        height: 800px;
        background-color: #fff;
        padding: 30px;
        border-radius: 10px;
        .titlebox {
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          .linebox {
            background: #f65f58;
            border-radius: 10px;
            margin-right: 20px;
            width: 7px;
            height: 36px;
          }
          .title {
            font-size: 30px;
            color: #2d3341;
          }
        }
        .newsList {
          .newstitle {
            display: flex;
            width: 100%;
          }
          img {
            width: 23px;
            height: 14px;
            margin-right: 10px;
          }
          .title {
            font-size: 16px;
            color: #2d3341;
            margin-bottom: 10px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 291px;
          }
          .date {
            font-size: 14px;
            color: #838a9d;
          }
        }
      }
    }
  }
}
@media (max-width: 1200px) {
  .main-content { width: auto; max-width: 100%; padding: 0 16px; box-sizing: border-box; }
  .content .left { width: 100%; }
  .content .right { width: 100%; margin-top: 16px; height: auto; }
}
@media (max-width: 992px) {
  .content {
    flex-direction: column;
    margin-bottom: 40px;
  }
  .left .title { font-size: 22px; }
  .right .titlebox .title { font-size: 22px; }
  .right .newsList img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  .right .newsList .newstitle {
    width: 100%;
  }
}
@media (max-width: 600px) {
  .head { padding: 12px 0; }
  .left { padding: 16px; }
  .right { padding: 16px; height: auto; }
  .left .title { font-size: 20px; margin-bottom: 16px; }
}
</style>
